import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { defineMessages } from 'react-intl';
import { useReducer } from 'react';
import { useMessage } from '@tmapy/intl';
import { SvgExternal, Collapsible, SIZE, TertiaryLink } from '@tmapy/style-guide';
import './LayerLegend.scss';
const msg = defineMessages({
    link: {
        id: 'legend.link',
        defaultMessage: 'Otevřít PDF verzi',
    },
});
const LegendHeader = ({ layerId, link, label }) => {
    const formatMessage = useMessage();
    const handleLinkCLick = (e) => e.stopPropagation();
    return (_jsxs("div", { className: 'sg-a-d-f sg-a-ai-c sg-a-jc-sb sg-a-cg-2', children: [_jsx("h3", { className: 'sg-u-type-h3', children: formatMessage.fallback([`legend.${layerId}`, `layer.${layerId}`]) || label }), link && (_jsx(TertiaryLink, { icon: { element: _jsx(SvgExternal, {}) }, size: SIZE.SML, href: link, target: '_blank', tooltip: formatMessage(msg.link), onClick: handleLinkCLick }))] }));
};
export const LinkLegend = (props) => {
    if (props.link) {
        return (_jsx("div", { className: 'lgd-linkLegend', children: _jsx(LegendHeader, { ...props }) }));
    }
    return null;
};
export const LayerLegend = (props) => {
    const [isClosed, toggleClosed] = useReducer((state) => !state, false);
    return (_jsx(Collapsible, { isClosed: isClosed, headElement: _jsx(LegendHeader, { ...props }), onClick: toggleClosed, children: props.children }));
};
//# sourceMappingURL=LayerLegend.js.map